<template>
  <v-col>
    <v-tabs v-model="tab">
      <v-tab>Export videos</v-tab>
      <v-tab>Import videos</v-tab>
      <v-tab>Import videos to amb</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <data-source-table
          itemController="ambassador-editor"
          itemIdentifyField="poi.name"
          :headers="headers"
          :options.sync="options"
          :selected-items.sync="selectedAd"
          ref="dataSourceRef"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-dialog
                v-model="downloadDialog.show"
                width="initial"
              >
                <template v-slot:activator="{}">
                  <v-btn
                    class="mx-2"
                    color="primary"
                    dark
                    fab
                    small
                    @click="download"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <slot>
                          <v-icon v-bind="attrs" v-on="on" dark>
                            mdi-download
                          </v-icon>
                        </slot>
                      </template>
                      Download
                    </v-tooltip>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>Download archive</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col>
                          <div v-if="downloadDialog.progress === 0">
                            <div>Archive preparation...</div>
                            <div class="text-center">
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </div>
                          </div>
                          <div v-else>
                            <div>Downloading...</div>
                            <v-progress-linear
                              v-model="downloadDialog.progress"
                              height="25"
                            >
                              <strong>{{ downloadDialog.progress }}%</strong>
                            </v-progress-linear>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="downloadDialog.show = false"
                    >
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:filter_poi.geotags>
            <GeotagList
              :geotag-model.sync="options.filters.geotags"
              dense
              multiple
            />
          </template>

          <template v-slot:item.poi.geotags="{ item }">
            {{ item.poi ? item.poi.geotags.map((geotag) => geotag.name).join(', ') : '' }}
          </template>

          <template v-slot:item.status="{ item }">
            <amb-status-icon
              :status="item.status"
              :statuses="statuses"
              :upload-user="item.user ? item.user.name : ''"
              :upload-user-date="item.redactor_change_date"
            >
            </amb-status-icon>
          </template>
        </data-source-table>
      </v-tab-item>

      <v-tab-item>
        <import-videos-component :displayType="false"></import-videos-component>
      </v-tab-item>

      <v-tab-item>
        <v-treeview
          :items="[
            {
              name: 'Example format in archive',
              children: [
                {
                  name: 'poi15979_amb9_National_Museum',
                  children: [
                    { name: 'video_name_1.mov', file: 'mdi-file-video' },
                    { name: 'video_name_2.mov', file: 'mdi-file-video' },
                    { name: 'video_name_3.mov', file: 'mdi-file-video' },
                  ]
                },
                {
                  name: 'poi15980_amb9_Hukuru_Miskiiy_Old_Friday_Mosque',
                  children: [
                    { name: 'video_name_1.mov', file: 'mdi-file-video' },
                    { name: 'video_name_2.mov', file: 'mdi-file-video' },
                    { name: 'video_name_3.mov', file: 'mdi-file-video' },
                  ]
                }
              ]
            }
          ]"
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
            </v-icon>
            <v-icon v-else>
              {{ item.file }}
            </v-icon>
          </template>
        </v-treeview>
        <v-row
          align="center"
          justify="space-between"
        >
          <v-col>
            <v-file-input
              v-model="videosAmbImport.file"
              accept=".zip"
              show-size
              label="Click here to import videos"
            />
          </v-col>
          <v-col>
            <v-text-field
              prefix="OR"
              v-model="videosAmbImport.folderName"
              label="Google drive unique folder name"
            />
          </v-col>
          <v-col cols="2">
            <v-select
              label="Payment status"
              v-model="videosAmbImport.payment_status"
              :items="paymentsStatuses"
              item-text="name"
              item-value="id"
            />
          </v-col>
          <v-col cols="2">
            <v-btn
              @click="uploadAmbArchive"
              :loading="videosAmbImport.loading"
              :disabled="!videosAmbImport.file && !videosAmbImport.folderName"
              color="blue darken-1"
            >
              Import
            </v-btn>
          </v-col>
        </v-row>
        <v-progress-linear
          v-show="videosAmbImport.loading"
          v-model="videosAmbImport.progress"
          height="25"
        >
          <strong>{{ Math.ceil(videosAmbImport.progress) }}%</strong>
        </v-progress-linear>

        <v-container>
          <v-row>
            <v-col class="text-h3">Video Amb list</v-col>
            <v-col class="text-right">
              <v-btn @click="getAmbVideosList" small>
                <v-icon small>mdi-reload</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="text-h3">
              <v-data-table
                :headers="headersAmb"
                :items="videosAmbList"
                :item-class="rowClass"
                disable-sort
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    @click="deleteRecord(item.id)"
                    fab dark x-small color="red"
                    class="mx-1">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <XlsxExport
            filename="video_amb_list.xlsx"
            :sheets="getExportSummaryWorkbook()"
            tooltip="export Video Amb list"
          />
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </v-col>
</template>

<script>
import { mapActions } from 'vuex';
import AmbStatusIcon from '../../components/AmbStatusIcon.vue';
import ImportVideosComponent from '../../components/ImportVideos.vue';
import DataSourceTable from '../../components/DataSource/DataTable.vue';
import GeotagList from '../../components/DataLists/GeotagList.vue';
import XlsxExport from '../../components/XlsxExport.vue';

export default {
  name: 'AmbassadorDownload',
  components: {
    GeotagList,
    XlsxExport,
    DataSourceTable,
    ImportVideosComponent,
    AmbStatusIcon,
  },
  data: () => ({
    tab: null,
    selectedAd: [],
    options: {
      filters: {},
    },
    statuses: [],
    downloadDialog: {
      show: false,
      progress: 0,
    },
    ajaxRequest: null,
    isLoadingGeotags: false,
    paymentsStatuses: [],
    videosAmbImport: {
      payment_status: 2,
      file: null,
      folderName: null,
      loading: false,
      progress: 0,
    },
    videosAmbList: [],
    headersAmb: [
      {
        text: 'archive',
        value: 'archive',
      },
      {
        text: 'index',
        value: 'index',
      },
      {
        text: 'video_file_path',
        value: 'video_file_path',
      },
      {
        text: 'poi_id',
        value: 'poi_id',
      },
      {
        text: 'amb_id',
        value: 'amb_id',
      },
      {
        text: 'amb_video_id',
        value: 'amb_video_id',
      },
      {
        text: 'payment_status',
        value: 'payment_status',
      },
      {
        text: 'user',
        value: 'user.name',
      },
      {
        text: 'created_at',
        value: 'created_at',
      },
      {
        text: 'status',
        value: 'status',
      },
      {
        text: 'error',
        value: 'error',
      },
      {
        text: 'actions',
        value: 'actions',
      },
    ],
  }),

  created() {
  },

  mounted() {
    this.$requestHelpers
      .get('api/admin/ambassador/poi/statuses')
      .then((response) => {
        this.statuses = response.data.result;
      });

    this.$requestHelpers
      .get('api/admin/ambassador/poi/payments-statuses')
      .then((response) => {
        this.paymentsStatuses = response.data.result;
      });

    this.getAmbVideosList();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    download() {
      if (this.selectedAd.length === 0) {
        return;
      }
      this.downloadDialog.show = true;

      this.ajaxRequest = this.axios.CancelToken.source();

      this.axios
        .post('api/admin/ambassador-editor/download',
          { ids: this.selectedAd.map((item) => item.id) },
          {
            onDownloadProgress: (progressEvent) => {
              const done = progressEvent.loaded;
              const totalProgress = progressEvent.total;
              this.downloadDialog.progress = this.percentProgress(done, totalProgress);
            },
            cancelToken: this.ajaxRequest.token,
          })
        .then(async (response) => {
          const files = response.data.result;
          if (Array.isArray(files) && files.length > 0) {
            const delay = (milliseconds) => new Promise((resolve) => {
              setTimeout(resolve, milliseconds);
            });

            const download = async (url) => {
              const a = document.createElement('a');
              a.download = '';
              a.href = url;
              a.style.display = 'none';
              document.body.append(a);
              a.click();

              // Chrome requires the timeout
              await delay(200);
              a.remove();
            };

            // download each url
            // eslint-disable-next-line no-restricted-syntax
            for (const url of files) {
              // eslint-disable-next-line no-await-in-loop
              await delay(1000);
              download(url);
            }

            this.setDownloadedStatus();
          } else {
            this.setSnack({
              color: 'red',
              text: 'error',
            });
          }
        }).catch((err) => {
          if (this.axios.isCancel(err)) {
            console.log('Request canceled', err.message);
          } else {
            this.setSnack({
              color: 'red',
              text: 'error',
            });
          }
        }).finally(() => {
          this.ajaxRequest = null;
          this.downloadDialog.show = false;
          this.downloadDialog.progress = 0;
        });
    },

    setDownloadedStatus() {
      this.$requestHelpers
        .post('api/admin/ambassador-editor/set-download-status',
          { ids: this.selectedAd.map((item) => item.id) })
        .then(() => {
          this.$refs.dataSourceRef.getApiData();
        });
    },

    percentProgress(done, total) {
      if (!total) {
        return 0;
      }

      const progress = Math.round((done / total) * 100);
      return parseInt(progress, 10);
    },

    downloadCancel() {
      if (this.ajaxRequest) {
        this.ajaxRequest.cancel('Operation canceled by the user.');
        this.ajaxRequest = null;
      }
    },

    uploadAmbArchive() {
      if (this.videosAmbImport.file) {
        this.videosAmbImport.loading = true;

        this.$requestHelpers
          .post('api/admin/ambassador/media/importAmbVideos',
            {
              stage: 'check',
              fileSize: this.videosAmbImport.file.size,
              fileName: this.videosAmbImport.file.name,
            })
          .then((response) => {
            if (response.data.success) {
              this.chunk(this.videosAmbImport.file, (file) => {
                const formData = new FormData();
                formData.append('zip_file', file);
                formData.append('payment_status', this.videosAmbImport.payment_status);
                formData.append('stage', 'uploadFile');

                this.$requestHelpers
                  .post('api/admin/ambassador/media/importAmbVideos',
                    formData)
                  .then((error) => {
                    this.videosAmbImport.file = null;
                    if (error.data?.result.length) {
                      this.showError(error.data.result);
                    }
                    this.getAmbVideosList();
                  })
                  .finally(() => {
                    this.videosAmbImport.loading = false;
                  });
              });
            } else {
              this.videosAmbImport.loading = false;
            }
          })
          .catch(() => {
            this.videosAmbImport.loading = false;
          });
      } else if (this.videosAmbImport.folderName) {
        this.$requestHelpers
          .post('api/admin/ambassador/media/importAmbVideos',
            {
              folderName: this.videosAmbImport.folderName,
              payment_status: this.videosAmbImport.payment_status,
              stage: 'uploadFile',
            })
          .then((error) => {
            this.videosAmbImport.file = null;
            if (error.data?.result.length) {
              this.showError(error.data.result);
            }
            this.getAmbVideosList();
          })
          .finally(() => {
            this.videosAmbImport.loading = false;
          });
      }
    },

    showError(message = 'error') {
      this.setSnack({
        color: 'red',
        text: message,
      });
    },

    getAmbVideosList() {
      this.$requestHelpers
        .post('api/admin/ambassador/media/importAmbVideos',
          {
            stage: 'videosAmbList',
          })
        .then((response) => {
          this.videosAmbList = response.data.result;
        });
    },

    exportAmbVideosList() {
      this.$requestHelpers
        .post('api/admin/ambassador/media/importAmbVideos',
          {
            stage: 'exportVideosAmbList',
          })
        .then((response) => {
          this.videosAmbList = response.data.result;
        });
    },

    deleteRecord(id) {
      this.$confirm('Are you sure you wand delete?').then((res) => {
        if (!res) return;

        this.$requestHelpers
          .post('api/admin/ambassador/media/importAmbVideos',
            {
              import_video_id: id,
              stage: 'delete',
            })
          .then((response) => {
            if (response.data.success) {
              this.videosAmbList.splice(this.videosAmbList.findIndex((e) => e.id === id), 1);
            }
          });
      });
    },

    rowClass(item) {
      let rowClass = '';
      switch (item.status) {
        case 'fail':
          rowClass = 'red lighten-2';
          break;
        case 'fail_upload':
          rowClass = 'red lighten-1';
          break;
        case 'done':
          rowClass = 'green lighten-2';
          break;
        default:
      }
      return rowClass;
    },

    chunk(file, onSuccess, onError) {
      const chunkNumber = 0;
      const identifier = `${file.size}-${file.name.replace('.', '')}`;

      this.chunkUploader(file, {
        identifier,
        chunkNumber,
        onError,
        onSuccess,
      });
    },

    chunkUploader(file, options) {
      const chunkSize = 1024 * 1024 * 100;

      const blockCount = Math.ceil(file.size / chunkSize);
      const start = options.chunkNumber * chunkSize;
      const end = Math.min(file.size, start + chunkSize);

      let currentChunkSize = chunkSize;
      if (options.chunkNumber + 1 === blockCount) {
        currentChunkSize = file.size - start;
      }

      const params = new FormData();
      params.append('stage', 'uploadArchive');
      params.append('resumableChunkNumber', options.chunkNumber + 1);
      params.append('resumableChunkSize', currentChunkSize);
      params.append('resumableCurrentChunkSize', currentChunkSize);
      params.append('resumableTotalSize', file.size);
      params.append('resumableType', file.type);
      params.append('resumableIdentifier', options.identifier);
      params.append('resumableFilename', file.name);
      params.append('resumableRelativePath', file.name);
      params.append('resumableTotalChunks', blockCount);
      params.append('file', file.slice(start, end), file.name);

      this.$requestHelpers
        .post('api/admin/ambassador/media/importAmbVideos', params, {
          headers: {
            'Content-type': 'application/x-www-form-urlencoded',
            Accept: 'application/json',
          },
        })
        .then((res) => {
          this.videosAmbImport.progress = this.percentProgress(end, file.size);

          if (end === file.size) {
            // eslint-disable-next-line no-unused-expressions
            options.onSuccess && options.onSuccess(res.data.result);
          } else {
            // eslint-disable-next-line no-param-reassign
            options.chunkNumber += 1;
            this.chunkUploader(file, options);
          }
        })
        .catch(() => {
          this.videosAmbImport.loading = false;
        });
    },

    getExportSummaryWorkbook() {
      return this.videosAmbList.length === 0
        ? [
          {
            name: 'Data',
            data: [{}],
          },
        ]
        : [
          {
            name: 'Data',
            data: this.videosAmbList,
          },
        ];
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'downloadDialog.show': function (value) {
      if (!value) {
        this.downloadCancel();
      }
    },
  },

  computed: {
    headers() {
      return [
        {
          text: 'poi id',
          value: 'poi_id',
        },
        {
          text: 'poi name',
          value: 'poi.name',
        },
        {
          text: 'geotags',
          value: 'poi.geotags',
        },
        {
          text: 'status',
          value: 'status',
          filter: { type: 'select', items: this.statuses },
        },
        {
          text: 'videos for upload',
          value: 'videos_for_editor_count',
        },
      ];
    },
  },

  deactivated() {
    this.$destroy();
  },
};
</script>

<style scoped>
</style>
